<template>
  <address-functionality
    :zip="zip"
    :area="area"
    :city="city"
    :street="street"
    :house="house"
    :apartment="apartment"
    @change-zip="changeZip"
    @change-area="changeArea"
    @change-city="changeCity"
    @change-street="changeStreet"
    @change-house="changeHouse"
    @change-apartment="changeApartment"
  >
    <template v-slot:default="{ zipMask, data, listeners, lists, loading }">
      <div>
        <field-with-title title="Индекс:">
          <v-text-field
            outlined
            v-mask="zipMask"
            :disabled="disabled || editDisable"
            :value="data.zip"
            @input="listeners.changeZip"
          ></v-text-field>
        </field-with-title>

        <field-with-title title="Субъект РФ: *">
          <v-text-field
            outlined
            readonly
            disabled
            value="Республика Татарстан"
          ></v-text-field>
        </field-with-title>

        <field-with-title title="Район: *">
          <v-autocomplete
            outlined
            return-object
            no-data-text="Начните ввод"
            item-text="name"
            :rules="requiredRules"
            :loading="loading.areaLoading"
            :disabled="!lists.areaList || disabled  || editDisable"
            :items="lists.areaList.filter(i=> !i.isCity)"
            :value="data.area"
            @change="listeners.changeArea"
          >
            <template v-slot:item="{item}">
              <strong v-if="item.isCity">{{item.name}}</strong>
              <template v-else>{{item.name}}</template>
            </template>
          </v-autocomplete>
        </field-with-title>

          <field-with-title title="Город: *">
          <v-autocomplete
            outlined
            return-object
            no-data-text="Начните ввод"
            item-text="name"
            :rules="requiredRules"
            :loading="loading.areaLoading"
            :disabled="!lists.areaList || disabled  || editDisable"
            :items="lists.areaList.filter(i=> i.isCity)"
            :value="data.area"
            @change="listeners.changeArea"
          >
            <template v-slot:item="{item}">
              <template >{{item.name}}</template>
            </template>
          </v-autocomplete>
        </field-with-title>

        <field-with-title title="Населенный пункт: *">
          <v-autocomplete
            outlined
            return-object
            no-data-text="Начните ввод"
            item-text="name"
            :loading="loading.cityLoading"
            :disabled="!lists.cityList || disabled  || editDisable"
            :items="lists.cityList"
            :value="data.city"
            v-model="data.city"
            @change="listeners.changeCity"
          ></v-autocomplete>
        </field-with-title>

        <field-with-title title="Улица: *">
          <v-autocomplete
            outlined
            return-object
            no-data-text="Начните ввод"
            item-text="name"
            :rules="requiredRules"
            :loading="loading.streetLoading"
            :disabled="!lists.streetList || disabled  || editDisable"
            :items="lists.streetList"
            :value="data.street"
            @change="listeners.changeStreet"
          ></v-autocomplete>
        </field-with-title>

        <v-row dense>
          <v-col cols="8">
            <field-with-title title="Дом: *">
              <v-autocomplete
                outlined
                return-object
                no-data-text="Начните ввод"
                :rules="requiredRules"
                item-text="name"
                :loading="loading.houseLoading"
                :disabled="!lists.houseList || disabled  || editDisable"
                :items="lists.houseList"
                v-model="data.house"
                @change="listeners.changeHouse"
              ></v-autocomplete>
            </field-with-title>
          </v-col>
          <v-col cols="4">
            <field-with-title :title="'Квартира'.concat(addressType==='802740002'?'/Офис':'')">
              <v-text-field
                outlined
                :disabled="!data.house || disabled  || editDisable"
                :value="data.apartment"
                @input="listeners.changeApartment"
              ></v-text-field>
            </field-with-title>
          </v-col>
        </v-row>
      </div>
    </template>
  </address-functionality>
</template>
<script>
  import { AxiosWrapper } from "@/assets/api/AxiosWrapper";
  import { mask } from "vue-the-mask";
  import AddressFunctionality from "../../../abstract/AddressFunctionality";
  import FieldWithTitle from "./FieldWithTitle";
  import { mapState } from "vuex";

  // тип адреса:
  // 802740000 - адрес регистрации,
  // 802740001 - адрес доставки,
  // 802740002 - адрес объекта
  // 802740003 -  адрес проживания
  export default {
    components: { FieldWithTitle, AddressFunctionality },
    directives: {
      mask
    },
    props: {
      // data
      addressType: String,
      // settings
      disabled: Boolean,
      address: Object,
      income: {
        default() {
          return {};
        }
      }
    },
    data: () => ({
      addressId: null,
      zip: null,
      area: null,
      city: null,
      street: null,
      house: null,
      apartment: null,

      requiredRules: [v=> v&&!!v.name|| "Поле обязательно"]
    }),
    computed : {
      ...mapState({
        editDisable: state => state.statements.editDisable
      })
    },
    watch: {
      income: {
        immediate: true,
        handler: function(value) {
          if (typeof value === "object" && value !== null)
            this.fillPresetData(value);
        }
      }
    },
    methods: {
      assemblyData() {
        let data = {
          addressType: this.addressType,
          addressId: this.addressId,
          index: this.zip || null,
          flat: this.apartment || null,
          street: this.street ? this.street.name : null,
          streetGuid: this.street ? this.street.value : null,
          house: this.house ? this.house.name : null,
          houseGuid: this.house ? this.house.value : null
        };

        if (this.area) {
          if (this.area.isCity) {
            data.city = this.area.name;
            data.cityGuid = this.area.value;
          } else {
            data.district = this.area.name;
            data.districtGuid = this.area.value;
            data.city = this.city ? this.city.name : null;
            data.cityGuid = this.city ? this.city.value : null;
          }
        }

        return data;
      },

      change() {
        let data = this.assemblyData();
        this.$emit("transferData", data);
      },
      changeZip(value) {
        this.zip = value;
        this.change();
      },
      changeArea(value) {
        this.area = value;
        this.change();
      },
      changeCity(value) {
        this.city = value;
        this.change();
      },
      changeStreet(value) {
        this.street = value;
        this.change();
      },
      changeHouse(value) {
        this.house = value;
        this.change();
      },
      changeApartment(value) {
        this.apartment = value;
        this.change();
      },

      fillPresetData(payload) {
        this.addressId = payload.addressId;
        this.zip = payload.index;
        this.apartment = payload.flat;

        this.street = payload.street ? {
          name: payload.street,
          value: payload.streetGuid
        } : null;

        this.house = payload.house ? {
          name: payload.house,
          value: payload.houseGuid
        } : null;

        if (payload.districtGuid) {
          this.area = {
            name: payload.district,
            value: payload.districtGuid,
            isCity: false
          };
          this.city = {
            name: payload.city,
            value: payload.cityGuid
          };
        } else {
          this.area = {
            name: payload.city,
            value: payload.cityGuid,
            isCity: true
          };
        }
      }
    },
    mounted () {
      if (this.address) {

        this.addressId = this.address.addressId;
        this.zip = this.address.index;
        this.apartment = this.address.flat;

        this.street = this.address.street ? {
          name: this.address.street,
          value: this.address.streetGuid
        } : null;

        this.house = this.address.house ? {
          name: this.address.house,
          value: this.address.houseGuid
        } : null;

        if (this.address.districtGuid) {
          this.area = {
            name: this.address.district,
            value: this.address.districtGuid,
            isCity: false
          };
          this.city = {
            name: this.address.city,
            value: this.address.cityGuid
          };
        } else {
          this.area = {
            name: this.address.city,
            value: this.address.cityGuid,
            isCity: true
          };
        }
      }
    }
  }
</script>
